import React from "react"
import { Pagination, Stack } from "@mui/material"

interface Props {
  pageCount: number
  page: number
  onPageChange: (value: number) => void
}

const ListingsPagination: React.FC<Props> = ({ pageCount, page, onPageChange }) => {
  return (
    <Stack spacing={2} alignContent="center" justifyContent="center" alignItems="center">
      <Pagination
        count={pageCount}
        page={page}
        onChange={(_e, value) => onPageChange(value)}
        variant="outlined"
        shape="rounded"
      />
    </Stack>
  )
}

export default ListingsPagination
